import { render, staticRenderFns } from "./RidesPassengerFilter.vue?vue&type=template&id=7ed8a134&scoped=true"
import script from "./RidesPassengerFilter.vue?vue&type=script&lang=js"
export * from "./RidesPassengerFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed8a134",
  null
  
)

export default component.exports